import React from 'react';
import { Helmet } from 'react-helmet-async';

const Schema = () => {
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "OnlineStore",
        "name": "FruValley Store",
        "url": "https://fruvalleykashmir.in/",
        "logo": "https://fruvalleykashmir.in/logo512.png",
        "description": "FruValley Store is a premium online marketplace for authentic Kashmiri Dry Fruits, Saffron, and Organic products.",
        "founder": {
            "@type": "Person",
            "name": "Uzair Farooq Naikoo"
        },
        "address": {
            "@type": "PostalAddress",
            "addressLocality": "Verinag",
            "addressRegion": "Jammu and Kashmir",
            "addressCountry": "IN"
        },
        "potentialAction": {
            "@type": "SearchAction",
            "target": "https://fruvalleykashmir.in/search/{search_term_string}",
            "query-input": "required name=search_term_string"
        },
        "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "email": "fruvalley.kashmir@gmail.com"
        }
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schemaData)}
            </script>
        </Helmet>
    );
};

export default Schema;
